import styled from 'styled-components';

export const CanvasContainer = styled.div`
  position: relative;
  height: 100%;
`;
